import axios from 'axios';

export default {
    FETCH_TESTIMONIALS ({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            // axios.post('login/authenticate', payload)
            axios.get('user/getTestimonialsData')
                .then((response) => {
                    const { data: { data : { payload } } } = response;
                    localStorage.setItem('testimonials', JSON.stringify(payload));
                    commit('SET_TESTIMONIALS', payload);
                    commit('TOGGLE_LOADING', false);
                    resolve(payload);

                })
                .catch((error) => {
                    console.log('action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    },
  UPDATE_TESTIMONIALS_ORDERING ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      return axios.post(`user/updTestimonialsDispOrder`, payload).then((response) => {
        commit('TOGGLE_LOADING', false);
        const { data: { data } } = response;
        console.log('UPDATE_LOGO_ORDER response ', response);
        resolve(data);
      }, (error) => {
        commit('TOGGLE_LOADING', false);
        console.log('UPDATE_EXPERT error ', error);
        reject(error);
      })
    })

  },
    GETSELECTEDTESTIMONIAL ({ commit }, testimonialId) {
        commit('TOGGLE_LOADING', true);
        return axios.get(`/user/getTestimonialsData?optionalTestimonialId=${testimonialId}`).then((response) => {
            commit('TOGGLE_LOADING', false);
            const { data: { data : { payload }} } = response;
            commit('SET_SELECTED_TESTIMONIAL', payload && payload[0])
        }, (err) => {
            commit('TOGGLE_LOADING', false);
            console.log('err ', err)
        })
    },
    ADD_TESTIMONIAL({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            console.log("add testimonial payload : ", payload);
            axios.post('user/addTestimonial', payload)
                .then((response) => {
                    console.log('ADD_TESTIMONIAL action fetch response : ', response);
                    const { data: { data } } = response;
                    commit('TOGGLE_LOADING', false);
                    resolve(data);
                })
                .catch((error) => {
                    console.log('ADD_TESTIMONIAL action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    },
    UPDATE_TESTIMONIAL({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            axios.post('user/updateTestimonial', payload)
                .then((response) => {
                    const { data: { data } } = response;
                    commit('TOGGLE_LOADING', false);
                    resolve(data);
                })
                .catch((error) => {
                    console.log('UPDATE_TESTIMONIAL action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/testimonials/actions.js